import type { ClientGateway } from "@kex/api";

import { useMutation } from "@tanstack/react-query";

import { requisitesApi } from "@shared/api";

import { useRequisitesQuery } from "./use-requisites-query";

interface QueryData {
  payload: ClientGateway.CreateBankAccountRequest;
  xTOTP: string;
}

export const useCreateRequisites = () => {
  const { invalidateRequisites } = useRequisitesQuery();

  const { error, mutateAsync, isPending } = useMutation({
    mutationFn: (data: QueryData) =>
      requisitesApi.postApiV1BankAccounts({
        createBankAccountRequest: data.payload,
        xTOTP: data.xTOTP,
      }),
    onSettled: invalidateRequisites,
  });

  return { createRequisites: mutateAsync, error, isPending };
};
